import $ from 'jquery';

const selectors = {
  body: "body.template-product-bundle",
  wrapper: ".product-feature_images",
  row: ".row_wrapper",
  btnShowMore: ".product-feature-more",
  collapsedWrapper: ".product-feature_images-bottom"
}

export default function () {
  const isBundle = $(`${selectors.body}`);
  const $showMoreBtn = $(`${selectors.btnShowMore}`);
  const btnTitle = $showMoreBtn.find('span').attr('data-title');
  const btnCollapseTitle = $showMoreBtn.find('span').attr('data-collapse-title');

  if (isBundle.length > 0) {
    const $collapsedWrapper = $(`${selectors.collapsedWrapper}`);
    
    function showHideContent (elem) {
      $(elem).toggleClass('active');

      if($(elem).hasClass('active')) {
        $(elem).find('span').text(btnCollapseTitle);
        $collapsedWrapper.slideDown(400);
      } else {
        $(elem).find('span').text(btnTitle);
        $collapsedWrapper.slideUp(400);
      }
    }

    $showMoreBtn.on('click', function () {
      showHideContent(this);
    });
  } else {
    const $wrapper = $(`${selectors.wrapper}`);
    let originalHeight, initialHeight;

    setTimeout(function(){
      originalHeight = $wrapper.height();
      initialHeight = $wrapper.find(`${selectors.row}`).eq(0).height();
      $wrapper.css('height', initialHeight);
    })


    $showMoreBtn.click(function () {
      $(this).toggleClass('active');

      if($(this).hasClass('active')) {
        $(this).find('span').text('see less');
        $wrapper.css('height', originalHeight);
      }
      else {
        $(this).find('span').text(btnTitle);
        $wrapper.css('height', initialHeight);
      }
    });
  }
}
